import * as React from 'react';
import * as Session from './Session';
import * as State from './AppState';
import * as TF from '../service/tradeflow';

export const API_LOGIN_URL = 'session/login';
export const API_CHANGEPASS_URL = 'session/changepass';
export const API_LOGOUT_URL = 'session/logout';
export const API_PROFILE_URL = 'session/profile';

export const API_SECLOOKUP_URL = 'infocat/seclookup';
export const API_ENTITYLOOKUP_URL = 'infocat/entitylookup';


export const API_DOMRECORDDETAIL_URL = 'trade/repo/domrecorddetail';
export const API_CONFIG_URL = 'trade/repo/config';
export const API_NEW_ORDER_URL = 'trade/repo/neworder';
export const API_NEW_ACCEPT_URL = 'trade/repo/newaccept';
export const API_ORDER_MODIFY_URL = 'trade/repo/modifyorder';
export const API_SECFILTER_URL = 'trade/repo/secfilter';
export const API_CAFILTER_URL = 'trade/repo/cafilter';
export const API_SECFILTER_MODIFY_URL = 'trade/repo/modifyfiltersec';
export const API_CAFILTER_MODIFY_URL = 'trade/repo/modifyfilterca';
export const API_CALIMITSLIST_URL = 'trade/repo/calimitslist';
export const API_CALIMITSGIVE_URL = 'trade/repo/calimitsgive';
export const API_CALIMITSTAKE_URL = 'trade/repo/calimitstake';
export const API_CALIMITS_MODIFY_URL = 'trade/repo/modifycalimits';

export const API_GETORCREATE_PRIVATECHAT_URL = 'trade/repo/getorcreate_chat';

export const _API_CMD_HEADER = 'X-Otc-AgentCmd';

export function apiUrl(path: string) {
    return TF.getApiUrl() + path;
}


//export function currentUser() {
//    var userdata = localStorage.getItem(OTC_USERSTATE);
//    if (userdata) {
//        let user: Session.UserState = JSON.parse(userdata);
//        return user;
//    }

//    return undefined;
//}


export function authHeader() {

    var user = Session.currentUser();
    if (user && user.identityState.authTokenState && user.identityState.authTokenState.token) {
        return { 'Authorization': 'Bearer ' + user.identityState.authTokenState.token };
    } else {
        return undefined;
    }

    //var userdata = localStorage.getItem(Session.OTC_USERSTATE);
    //if (userdata) {
    //    let user: Session.UserState = JSON.parse(userdata);

    //    if (user && user.identityState.authTokenState && user.identityState.authTokenState.token) {
    //        return { 'Authorization': 'Bearer ' + user.identityState.authTokenState.token };
    //    } else {
    //        return undefined;
    //    }
    //}
}










//import * as React from 'react';
//import * as Session from './Session';
//import * as State from './AppState';
//import * as TF from '../service/tradeflow';


//export const OTC_REPO_USERSTATE = '_otc.user';

//export const API_LOGIN_URL = 'session/login';
//export const API_CHANGEPASS_URL = 'session/changepass';
//export const API_LOGOUT_URL = 'session/logout';
//export const API_SECLOOKUP_URL = 'infocat/seclookup';
//export const API_ENTITYLOOKUP_URL = 'infocat/entitylookup';
//export const API_DOMRECORDDETAIL_URL = 'trade/repo/domrecorddetail';
//export const API_CONFIG_URL = 'trade/repo/config';
//export const API_NEW_ORDER_URL = 'trade/repo/neworder';
//export const API_NEW_ACCEPT_URL = 'trade/repo/newaccept';
//export const API_ORDER_MODIFY_URL = 'trade/repo/modifyorder';
//export const API_SECFILTER_URL = 'trade/repo/secfilter';
//export const API_CAFILTER_URL = 'trade/repo/cafilter';
//export const API_SECFILTER_MODIFY_URL = 'trade/repo/modifyfiltersec';
//export const API_CAFILTER_MODIFY_URL = 'trade/repo/modifyfilterca';



////var config = {
////    //apiUrl: 'http://localhost:9350/api/'
////    apiUrl: ''
////};

////export function setApiUrl(url: string | undefined) {
////    window.config = { apiUrl: url ? url : '' };
////    console.log('config');
////    console.log(config);
////    return config.apiUrl;
////}

//export const _API_CMD_HEADER = 'X-Otc-AgentCmd';

//export function apiUrl(path: string) {
//    //return config.apiUrl + path;
//    return TF.getApiUrl() + path;
//}

////export function authHeader1() {

////    if (State.default.user && State.default.user.identityState) {
////        let ident = State.default.user.identityState;
////        if (ident.authenticationTokens && ident.authenticationTokens.length > 0) {

////            let token = JSON.parse(ident.authenticationTokens[0].token);

////            if (token) {
////                return { 'Authorization': 'Bearer ' + token };
////            } else {
////                return {};
////            }
////        }
////        else 
////            return {};
////    }
////    else
////        return {};
////}

//export function currentUser() {
//    var userdata = localStorage.getItem(OTC_REPO_USERSTATE);
//    if (userdata) {
//        let user: Session.UserState = JSON.parse(userdata);
//        return user;
//    }

//    return null;
//}


//export function authHeader() {
//    var userdata = localStorage.getItem(OTC_REPO_USERSTATE);
//    if (userdata) {
//        let user: Session.UserState = JSON.parse(userdata);

//        if (user && user.identityState.authTokenState && user.identityState.authTokenState.token) {
//            return { 'Authorization': 'Bearer ' + user.identityState.authTokenState.token };
//        } else {
//            return {};
//        }
//    }
//}
